import { marketSearchApi } from '@envato/foundation-types'

const ALL_PLATFORMS_FOR_CATEGORY_ROOT: Record<string, Array<string>> = {
  all: [
    'WordPress',
    'Android',
    'HTML5',
    'Construct',
    'iOS',
    'PHP',
    'Google',
    'jQuery',
    'MySQL',
    'CSS3',
    'Magento',
    '.NET',
    'PrestaShop',
    'CSS2',
    'Flutter',
    'OpenCart',
    'Ionic',
    'Joomla',
    'Node.js',
    'Bootstrap',
    'Muse',
    'AngularJS',
    'ReactJS',
    'Edge',
    'Drupal',
    'GameMaker',
    'VirtuaMart',
    'Laravel',
    'Adobe',
    'Concrete5',
    'EXT',
    'tvOS'
  ],
  css: ['CSS3', 'CSS2'],
  'edge-animate-templates': ['Edge'],
  html5: ['HTML5', 'Construct', 'Google'],
  javascript: [
    'jQuery',
    'Node.js',
    'AngularJS',
    'ReactJS',
    'EXT',
    'MooTools',
    'CSS3'
  ],
  mobile: [
    'Android',
    'iOS',
    'Flutter',
    'Ionic',
    'HTML5',
    'PHP',
    'CSS3',
    'WordPress',
    'MySQL',
    'Bootstrap',
    'Node.js',
    'AngularJS',
    'ReactJS',
    'jQuery',
    'Laravel',
    'CSS2',
    'Adobe',
    '.NET',
    'tvOS',
    'OpenCart',
    'EXT JS',
    'WatchOS'
  ],
  net: ['.NET'],
  'php-scripts': ['PHP', 'MySQL'],
  plugins: [
    'Magento',
    'PrestaShop',
    'OpenCart',
    'Joomla',
    'Muse',
    'Drupal',
    'VirtueMart',
    'WordPress',
    'Concrete5',
    'PHP',
    'Zen',
    'MySQL',
    'osCommerce',
    'HTML5',
    'jQuery'
  ],
  skins: ['Bootstrap'],
  wordpress: ['WordPress']
}

export default function applyCodeCanyonFilter(
  category: string,
  tree: marketSearchApi.IFilterTreeNode[]
): marketSearchApi.IFilterTreeNode[] {
  const categoryRoot = category.split('/').shift() as string

  const allowedPlatforms =
    ALL_PLATFORMS_FOR_CATEGORY_ROOT[categoryRoot.toLowerCase()]

  return tree.filter(
    entry => entry.name && allowedPlatforms.indexOf(entry.name) != -1
  )
}
